import { render } from "./Wishlist.vue?vue&type=template&id=40ae2ae0"
import script from "./Wishlist.vue?vue&type=script&lang=js"
export * from "./Wishlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Components/Wishlist.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40ae2ae0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40ae2ae0', __exports__)) {
    api.reload('40ae2ae0', __exports__)
  }
  
  module.hot.accept("./Wishlist.vue?vue&type=template&id=40ae2ae0", () => {
    api.rerender('40ae2ae0', render)
  })

}


export default __exports__